import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Spinner, Alert, Container } from 'react-bootstrap';

export const ProtectedRoute = ({ children, requiresAdmin = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  // Mostrar loading com indicação mais clara do que está acontecendo
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Container className="text-center">
          <div className="mb-3">
            <img 
              src="/logo-mm-eventos.png" 
              alt="MM Eventos" 
              style={{ maxHeight: '60px', opacity: 0.8 }}
            />
          </div>
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Carregando Hub de Sistemas...</p>
          <small className="text-muted">
            Conectando e verificando acessos...
            <br />
            MM Eventos® Health Division
          </small>
        </Container>
      </div>
    );
  }

  // Se não há usuário logado
  if (!user) {
    console.log('ProtectedRoute: Usuário não autenticado, redirecionando para login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se requer admin e usuário não é admin
  if (requiresAdmin && !isAdmin) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Container className="text-center">
          <Alert variant="danger">
            <Alert.Heading>🚫 Acesso Negado</Alert.Heading>
            <p>Você não tem permissão para acessar esta área.</p>
            <p>Apenas administradores podem gerenciar usuários e sistemas.</p>
            <hr />
            <div className="d-flex justify-content-center">
              <button 
                className="btn btn-primary"
                onClick={() => window.location.href = '#/hub'}
              >
                Voltar ao Hub
              </button>
            </div>
          </Alert>
        </Container>
      </div>
    );
  }

  return children;
};